<template>
    <!-- Job dialog -->
        <v-layout>
       <!-- success alert -->
    <v-dialog
      v-model="alert"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Informations enregistrées</v-card-title>

        <v-card-text>
          Les informations de travail ont été Sauveguardées!
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="alert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Success Alert end -->
                <div class="container" id="showCurrentJobInfo">
       <form @submit.prevent="validateCurrentJobInfo">
           <v-container fluid grid-list-xl>
               <v-layout row wrap>
          <v-flex xs12>
               <v-text-field
            label="Depuis combien de temps vous travaillez?"
             name="Temps au travaille"
                :error-messages="errors.collect('Temps au travaille')"
                v-validate="'required'"
            type="number" min="0"
            append-icon="watch"
            v-model.number="form.timeOnCurrentJob.amount">
             <v-select
             label= "fréquence"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence"
                :error-messages="errors.collect('fréquence')"
                v-validate="'required'"
        v-model="form.timeOnCurrentJob.frequency"
           :items="['jours','semaines', 'mois', 'ans']">
        </v-select>
            </v-text-field>            
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
          label="Nom de votre poste"
          name="Nom du poste"
            :error-messages="errors.collect('Nom du poste')"
            v-validate="'required'"
          type="text"
          v-model="form.jobPosition"></v-text-field>
        </v-flex>
         <v-flex xs12 sm6>
            <label for="jobRepartition">Répartition de votre temps au travail?</label>
            <v-radio-group
            name="répartition de temps"
            :error-messages="errors.collect('répartition de temps')"
            v-validate="'required'"
            v-model="form.jobRepartition"
                row>
                <v-radio label="Journalier" value="Journalier">Journalier</v-radio>
                <v-radio label="Temps plein" value="Temps plein">Temps plein</v-radio>
                </v-radio-group>
          </v-flex>
          <v-flex xs12 sm6>
           <v-text-field label="Combien d'emplois avez vous?"
          name="nombre d'emplois"
          :error-messages="errors.collect('nombre d\'emplois')"
            v-validate="'required'"
          type="number" min="1" max="10"
          v-model.number="form.numberOfJobs"/>
          </v-flex>
         
        <v-flex xs12 sm6>
          <v-text-field label="Nombre d'heures par semaine?" 
          name="heures par semaine"
          type="number" min="1"
            :error-messages="errors.collect('heures par semaine')"
            v-validate="'required'"
          v-model.number="form.jobWeeklyHours"/>
        </v-flex>
       <v-flex xs12 sm6>
           Temps de trajet de la maison à votre emploi?
       <v-select
          name="trajet de la maison"
          :error-messages="errors.collect('trajet de la maison')"
          v-model="form.homeTravelDistance"
          :items="['0 à 30 minutes', '30 à 60 minutes', '60 à 120 minutes']"
           v-validate="'required'"
           solo>
        </v-select>
       </v-flex>
        <v-flex xs12 sm6>
            Temps de trajet de votre emploi à l'église?
            <v-select
          v-model="form.jobTravelDistance"
          :items="['0 à 30 minutes', '30 à 60 minutes', '60 à 120 minutes']"
          name="trajet de votre emploi"
          :error-messages="errors.collect('trajet de votre emploi')"
          v-validate="'required'"
          solo
        ></v-select>
        </v-flex>
       <v-flex xs12 sm6>
       <v-text-field
       append-icon="attach_money"
       label ="Coût de transport pour aller travailer?"
        name="coût de transport"
            :error-messages="errors.collect('coût de transport')"
            v-validate="'required'"
        type="number"
        min="0"
        v-model.number="form.jobTravelCost"
        ></v-text-field>
       </v-flex>
         <v-flex xs12 sm6>
         <!-- <label for="jobTravelMode">Moyen de transport pour aller travailer?"</label> -->
            <v-select
          v-model="form.jobTravelMode"
          :items="['Marche', 'Autobus', 'Taxi', 'Vélo', 'Motocyclette', 'Camionette', 'Voiture']"
          label="Moyen de transport"
           name="moyen de transport"
            :error-messages="errors.collect('moyen de transport')"
            v-validate="'required'"
        ></v-select>
         </v-flex>
      <v-flex xs12>
        <v-btn type="submit" color="primary" class="btn red">Sauveguarder</v-btn>
       
      </v-flex>
               </v-layout>
           </v-container>
       </form>
                </div>
        </v-layout>

</template>

<script>
/* eslint-disable */
import fr from "vee-validate/dist/locale/fr";
import firebase, { functions } from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import { db } from "@/api/firebaseInit";
import { auth } from "@/api/firebaseInit";

Validator.localize("fr", fr);
export default {
  name: "current-job",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
        headers: [
          { text: 'Prénom et Nom', value: 'lastName' },
          { text: 'Code d\'accès', value: 'accessCode' },
          { text: 'Telephone', value: 'phone' },
        ],
      alert: false,
      isWorking: true,
      member_id: '',
      member: null,
      showCurrentJobInfo: false,
      showEducation: false,
      showNotAvailable: false,
      showHouse: false,
      // form: {
      //   imageUrl: '/static/avatar/avatar.png',
      //   timeOnCurrentJob: {
      //     amount: 6,
      //     frequency: "mois"
      //   },
      //   jobPosition: null,
      //   numberOfJobs: 1,
      //   jobRepartition: "Temps plein",
      //   jobWeeklyHours: 40,
      //   jobTravelTime: {
      //     hours: 0,
      //     minutes: 30
      //   },
      //   jobTravelDistance: "plus de 30 km",
      //   jobTravelMode: "Vélo",
      //   jobTravelCost: 0,
      //   isWorking: "Non",
      // },
    };
  },
  mounted() {
    this.$validator.localize("fr", this.dictionary);
    
  },
  computed: {
    form () {
      let form = this.$store.getters.getCurrentMember;
      this.member_id = form.id;
      
      return form;
    },
  },
  watch: {
    form(val) {
       this.$store.commit('currentMember', val);
    }
  },
  methods: {
    validateCurrentJobInfo() {
      this.$validator.validateAll().then(result => {
  
          this.saveCurrentJobInfo();
        })
    },
    fetchData () {
       
         db.collection('Census').doc(this.member_id)
        .get ()
         .then((doc ) => {
            const form = {
            timeOnCurrentJob: doc.data().timeOnCurrentJob,
            jobPosition: doc.data().jobPosition,
            numberOfJobs: doc.data().numberOfJobs,
            jobRepartition: doc.data().jobRepartition,
            jobWeeklyHours: doc.data().jobWeeklyHours,
            jobTravelDistance: doc.data().jobTravelDistance,
            homeTravelDistance: doc.data().homeTravelDistance,
            jobTravelMode: doc.data().jobTravelMode,            
            jobTravelCost: doc.data().jobTravelCost
            }
           this.$store,commit('currentMember', this.form)
            })
          },
    saveCurrentJobInfo () {
         db.collection('Census').doc(this.member_id)
        .update({
            timeOnCurrentJob: this.form.timeOnCurrentJob,
            jobPosition: this.form.jobPosition,
            numberOfJobs: this.form.numberOfJobs,
            jobRepartition: this.form.jobRepartition,
            jobWeeklyHours: this.form.jobWeeklyHours,
            jobTravelDistance: this.form.jobTravelDistance,
            homeTravelDistance: this.form.homeTravelDistance,
            jobTravelMode: this.form.jobTravelMode,            
            jobTravelCost: this.form.jobTravelCost,
            })
            .then(() => {
              this.showCurrentJobInfo = false
            this.alert = true
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    photoDialog() {
      this.$router.push("/appphoto");
    }
  }
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/pages/form/steppers/CurrentJob.vue